/* eslint-disable */
/*
 * A dropdown menu that allows you to select, rename, and delete an
 * item.  Also allows you to create new items.
 */

import React, { Component } from 'react'
import Dropdown, {DropdownTrigger, DropdownContent} from 'react-simple-dropdown'
import '../../stylesheets/lexicon.css'

/*
 * TODO:
 * 
 * Figure out consistent indenting for code/markup.
 * 
 * Add more props (e.g. for styling).
 * 
 * General beautification (e.g. highlighting, dropdown arrow, etc).
 *
 */

/*
 * Props:
 *
 *  items - A list of objects, each of which must have a "name" key. The name key is displayed; the
 *          object is returned on read. Example: [ { name: 'Red', value: 0xff000 }, {name: 'Green', value: 0x00ff00 } ]
 * 
 *  trigger - A string to put in the trigger. Typically, this should be the name of the currently selected object.
 *
 *  label - A string describing what the thing is. E.g. "Color". Used in headings and such.
 *
 *  onCreate - Called when the user selects the create action. A function of one argument, the name
 *             the user entered.
 * 
 *  onRead - Called when the user selects an item. A function of one argument, the object (e.g. {name: 'Red', value: 0xff0000})
 *
 *  onUpdate - Called when the user renames an item. A function of two arguments, the object and the new name.
 *
 *  onDelete - Called when the user deletes an item. A function of one argument, the object.
 * 
 */

class CRUDDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newItemName: '',	   /* Name of a new item to create */
      renameItemName: '',  /* Name we changing TO */
      renaming: undefined, /* If we're renaming, the index into props.items of the item we're renaming */
    }
  }

  /*
   * Called when you confirm a rename by pressing enter key or
   * clicking on rename while renaming an item.
   */
  
  renameItem = (fromObj) => {
    if (this.state.renameItemName) {
      this.props.onUpdate(fromObj, this.state.renameItemName)
      this.setState({renameItemName: '', renaming: undefined})
      this.refs.CRUDDropdownRef.hide()
    }
  }

  /*
   * Called when you confirm the creation of a new item by
   * pressing the enter key or clicking on create while
   * creating an object.
   */

  createItem = () => {
    if (this.state.newItemName) {
      this.props.onCreate(this.state.newItemName)
      this.setState({newItemName: ''})
      this.refs.CRUDDropdownRef.hide()
    }
  }

  render() {
    let label = this.props.label || 'Item'
    return (
      <Dropdown ref="CRUDDropdownRef">
	<DropdownTrigger>{this.props.trigger ? this.props.trigger : 'Create ' + label} &#9660;</DropdownTrigger>
	<DropdownContent>
	  <table>
	    <thead>
	      <tr><td>{label}</td><td colSpan="2">Actions</td></tr>
	    </thead>
	    <tbody>
	      { this.props.items.map((obj, ii) => {
	      return (
	      <tr key={ii}>
		{ (this.state.renaming === ii) ? 
		<td><input type="text"
			   placeholder={obj.name}
			   value={this.state.renameItemName}
			   onChange={evt => { this.setState({renameItemName: evt.target.value})}}
 			   onKeyPress={evt => {
		             if (evt.key === 'Enter') {
		               evt.preventDefault()
			       evt.stopPropagation()
			       this.renameItem(obj)
			     }}}
		  /></td>
		  :
		  <td className="CRUDDropdownName" onClick={e => {
		      this.props.onRead(obj)
		      this.refs.CRUDDropdownRef.hide()
		  }
		  }>{obj.name}</td> }
		<td>
		  <button disabled={this.state.renaming !== undefined && (this.state.renaming !== ii || this.state.renameItemName === '') }
			  onClick={(e) => {
			      e.preventDefault();
			      if (this.state.renaming === ii) {
				this.renameItem(obj)
			      } else {
				this.setState({renaming: ii});
			      }
			  }}>
		    Rename
		  </button>
		</td>
		<td><button onClick={(e) => { e.preventDefault(); this.props.onDelete(obj); }}>Delete</button></td>
	      </tr>
	      ) } ) }
	      <tr key="newItemRowKey">
		<td><input type="text" placeholder={"New " + label}
			   value={this.state.newItemName}
			   onChange={evt => {
			       this.setState({newItemName: evt.target.value})
			   } }
			   onKeyPress={evt => {
			       if (evt.key === 'Enter') {
				 evt.preventDefault()
				 evt.stopPropagation()
				 this.createItem()
			       }
			   }} />
		</td>
		<td colSpan="2">
		  <button
		    disabled={this.state.newItemName === ''}
		    onClick={e => {
			e.preventDefault()
			this.createItem()
		    } }>{"Create " + label}</button>
		</td>
	      </tr></tbody></table>
	</DropdownContent>
      </Dropdown>
    )
  }
}

export default CRUDDropdown
